import { useState } from 'react'

import { PlannedBreakFragment } from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { Shift, View } from 'modules/shift_management/lib/types'
import { useGetPlannedBreaks } from 'modules/time_planning/hooks/plannedBreaks/useGetPlannedBreaks'
import PlannedBreaks from 'modules/time_planning/store/internal/collections/plannedBreaks'

// TODO: Remove this hook once 'dev_shift_management_graphql_migration' is done
const useFetchPlannedBreaks = (shifts: Shift[], view: View) => {
  const shiftIds = shifts.map((shift) => shift.id)
  const { loading, plannedBreaksCollection, refetch } = useGetPlannedBreaks({
    variables: { shiftIds },
    skip: !shiftIds.length,
  })

  const [plannedBreaks, setPlannedBreaks] = useState(plannedBreaksCollection)

  const refreshPlannedBreaks = useUnsafeCallback(async () => {
    if (!shiftIds.length) return

    const { data } = await refetch()
    const newPlannedBreaks: PlannedBreakFragment[] = data
      ? data.timePlanning.plannedBreaksConnection.nodes
      : []
    const newPlannedBreaksCollection = PlannedBreaks.buildFromRequest(newPlannedBreaks)

    const shiftsToQuery = new Set(shiftIds)
    const otherPlannedBreaks = plannedBreaks.plannedBreaks.filter(
      (b) => b.shiftId && !shiftsToQuery.has(b.shiftId)
    )

    setPlannedBreaks(
      new PlannedBreaks([...otherPlannedBreaks, ...newPlannedBreaksCollection.plannedBreaks])
    )
  }, [plannedBreaks, refetch, shiftIds])

  useUnsafeEffect(() => {
    refreshPlannedBreaks()
  }, [refetch, shifts]) // eslint-disable-line react-hooks/exhaustive-deps

  useUnsafeEffect(() => {
    setPlannedBreaks(new PlannedBreaks([]))
  }, [view]) // eslint-disable-line react-hooks/exhaustive-deps

  return { loading, plannedBreaks }
}

export default useFetchPlannedBreaks
